import { Icon, type IconProps } from "@chakra-ui/react"
import { memo } from "react"

export const CreateIcon = memo((props: IconProps) => {
	return (
		<Icon fill="none" viewBox="0 0 32 48" {...props}>
			<path
				d="M28 8H4c-2.2 0-4 1.8-4 4v24c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V12c0-2.2-1.8-4-4-4z"
				fill="#383037"
			/>
			<path
				d="M27.3 9.1c-.2-.1-.3-.2-.4-.2H26.6l-.1.1-.1.1-2.4 7.2-3.1.5-2.2-2.3L20.9 8h-4.2c-1.9 1.1-3.3 2.8-4.1 4.9-1.1 3.3-.2 7 2.2 9.4l-5.7 17c-.1.3-.1.5-.2.7H17l5.1-15.3c3.4-.4 6.3-2.8 7.5-6.1 1.3-3.3.4-7.1-2.3-9.5z"
				fill="#1f1a1d"
			/>
			<path
				d="M24.3 7.1c-.2-.1-.3-.2-.4-.2H23.6l-.1.1-.1.1-2.4 7.2-3.1.5-2.2-2.3 2.4-7v-.2s0-.1-.1-.1v-.1l-.1-.1c-.1-.1-.3-.1-.4-.1-3.6.3-6.7 2.7-7.8 6.1-1.1 3.3-.2 7 2.2 9.4l-5.7 17c-.7 2 .4 4.2 2.4 4.9 2 .7 4.2-.4 4.9-2.4l5.8-17.1c3.4-.4 6.3-2.8 7.5-6.1 1.1-3.4.2-7.2-2.5-9.6z"
				fill="#ffebd2"
			/>
		</Icon>
	)
})
